<template>
  <div id="app">
    <BaseNavigation :active-navi-index="activeNaviIndex" />
    <div :class="['contents', { scrolled: scrolled }]">
      <router-view />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'

import BaseNavigation from '@/components/organisms/BaseNavigation'

export default {
  name: 'App',
  components: {
    BaseNavigation
  },
  data () {
    return {
      onScrollFunction: undefined,
      scrolled: false
    }
  },
  computed: {
    ...mapState({
      activeNaviIndex: (state) => state.activeNaviIndex
    })
  },
  watch: {
    // ページ移動時にタイトルを整形していく
    '$route' (to, from) {
      document.title = to.meta.title ? `CCS - ${to.meta.title}` : 'CCS'
    }
  },
  created () {
    this.onScrollFunction = _.throttle(
      () => {
        this.scrolled = (document.documentElement.scrollTop || document.body.scrollTop) > 0
      }, 300)
    window.addEventListener('scroll', this.onScrollFunction)
  },
  destroyed () {
    window.removeEventListener('scroll', this.onScrollFunction)
    this.onScrollFunction = undefined
  }
}
</script>
